import { Config } from "../core/config/config.js";
import React from "react";
export class Documentation extends React.Component<any, any>{
    private url: string;

    constructor(props) {
        super(props)
        this.url = `${props.BaseUrl}${props.Version}/${Config.user.languageId === 0 ? "de" : "en"}`;
    }


    render() {
        return <iframe id="doc" key={this.url} src={this.url} style={{ height: '100%', width: '100%' }}></iframe >;
    }
}